import { useQuery } from '@tanstack/react-query';
import { QueryKey } from 'types/query';
import { conversationsClient } from 'clients/ConversationsClient/ConversationsClient';

export const useGetUnreadConversationsAmount = (teamView: boolean) => {
  return useQuery([QueryKey.useGetUnreadConversationsAmount, teamView], async () => {
    const response = await conversationsClient.getUnreadConversationsAmount({ teamView });
    if (response.status !== 200) return 0;
    return response.data.amount;
  });
};
